'use strict'

import ObjectCardDialog from '../components/Card/ObjectCardDialog.vue'
import AskPropsWindow from '../components/AskPropsWindow.vue'
import DeltaDialog from '../components/DeltaDialog.vue'

class DialogWrapper {
  constructor (targetComponent) {
    this.targetComponent = targetComponent
    this.dialogInner = null
  }

  show (config) {
    const target = this.targetComponent
    this.dialogInner = target.$q.dialog({
      component: DeltaDialog,
      parent: target,
      config: config
    })
    return this
  }

  ask (callback, header, propsConfig, buttons, warning) {
    const target = this.targetComponent
    this.dialogInner = target.$q.dialog({
      component: AskPropsWindow,
      parent: target,
      config: {
        callback,
        header,
        warning,
        propsConfig,
        buttons
      }
    })
    return this
  }

  hide () {
    if (this.dialogInner) {
      this.dialogInner.hide()
    }
  }
}

const $d = {
  getUrlObjectCard: null,
  showAdminObjectCard: null,
  dialog: function (terget) {
    return new DialogWrapper(terget)
  },

  access: null, // TODO function (this)

  get mobileDevice () {
    return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
  },

  getYandexMapsLocationUrl: function (location, mobile = false) {
    if (location) {
      let coordinates
      if (Array.isArray(location)) {
        if (location.length === 2 && location[0] != null && location[1] != null) {
          coordinates = location
        }
      } else if (typeof location === 'string') {
        coordinates = location // Строка "37.5028190612793,55.777095794677734"
      } else {
        if (location.lon != null && location.lat != null) {
          coordinates = [location.lon, location.lat]
        }
      }

      if (coordinates) {
        if (mobile) {
          return 'yandexmaps://maps.yandex.com/?ll=' + coordinates + '&pt=' + coordinates + '&z=15'
        } else {
          let coordinatesReversed
          if (typeof coordinates === 'string') {
            coordinatesReversed = coordinates.split(',').toReversed()
          } else {
            coordinatesReversed = coordinates.toReversed()
          }
          return 'http://yandex.com/maps/?ll=' + coordinates +
           '&l=map,stv&mode=search&sll=' + coordinates +
           '&text=' + coordinatesReversed +
           '&panorama[point]=' + coordinates +
           '&tab=panorama' +
           '&panorama[full]=true' +
           '&z=19'
        }
      }
    }
  },
  getNavigatorHref: function (location, type) {
    if (location) {
      let coordinates
      if (Array.isArray(location)) {
        if (location.length === 2 && location[0] != null && location[1] != null) {
          coordinates = location
        }
      } else if (location.lon != null && location.lat != null) {
        coordinates = [location.lon, location.lat]
      }

      if (coordinates) {
        if (type === 'yandex') {
          if (this.mobileDevice) {
            return 'yandexnavi://build_route_on_map?lat_to=' + coordinates[1] + '&' + 'lon_to=' + coordinates[0]
          } else {
            return 'https://yandex.ru/maps/?mode=routes&rtext=~' + coordinates[1] + ',' + coordinates[0]
          }
        } else if (type === 'google') {
          return 'https://www.google.com/maps/search/?api=1&query=' + coordinates[1] + ',' + coordinates[0]
        } else if (type === '2gis') {
          if (this.mobileDevice) {
            return 'dgis://2gis.ru/routeSearch/rsType/car/to/' + coordinates[0] + ',' + coordinates[1]
          } else {
            return 'https://2gis.ru/moscow/directions/points/|' + coordinates[0] + ',' + coordinates[1]
          }
        }
      }
    }
  },
  getObjectUrlOnAdminPage: function (id) {
    return (process.env.VUE_APP_BACKEND_HREF || '/') + 'pages/objectconf/' + id
  },
  getTaskUrlInD2: function (id) {
    return '/task/' + id + '/document/' + id
  },
  getReportUrl: function (reportData) {
    if (reportData && reportData.id && reportData.requestId) {
      return '/task/' + reportData.requestId + '/document/' + reportData.id
    }
  },
  isWindows: function () {
    return !!(navigator.userAgentData && navigator.userAgentData.platform === 'Windows' || navigator.platform === 'Win32' || navigator.appVersion && navigator.appVersion.indexOf('Win') != -1)
  },
  isIOS: function () {
    if (navigator.userAgentData) {
      const platform = navigator.userAgentData.platform
      return platform === 'iPhone' || platform === 'iPad' || platform === 'iPod'
    } else if (navigator.platform === 'iPhone' || navigator.platform === 'iPad' || navigator.platform === 'iPod') {
      return true
    }
    return false
  },
  _androidPhotoPickerAffected: undefined,
  async isAndroidPhotoPickerAffected () {
    if (this._androidPhotoPickerAffected !== undefined) {
      return this._androidPhotoPickerAffected
    }
    let result = false
    const uaData = navigator.userAgentData
    if (uaData && uaData.platform === 'Android' && uaData.getHighEntropyValues) {
      try {
        const high = await uaData.getHighEntropyValues(['platformVersion'])
        const major = parseInt((high.platformVersion || '').split('.')[0], 10)
        result = Number.isFinite(major) && major >= 14
      } catch (e) {
        result = false
      }
    }
    this._androidPhotoPickerAffected = result
    return result
  }
}

function getObjectCardURL (objectIdOrKey, objectTypeKey, subtypeKey) {
  switch (objectTypeKey) {
    case 'vehicleProvision':
      return '/transport/vehicleProvision/vehicleProvisionRequests/' + objectIdOrKey
    case 'serviceObjectMaintenanceNote':
      return '/journals/serviceObjectMaintenanceNote/' + objectIdOrKey
    case 'krotosCameraMetroIncident':
      return '/journals/krotosCameraMetroIncident/' + objectIdOrKey
    default:
      return '/object/' + objectTypeKey + '/' + objectIdOrKey + (subtypeKey ? '?subtypeKey=' + subtypeKey : '')
  }
}

const deltaPlugins = {
  install: function (Vue, options) {
    Vue.prototype.$d = $d

    Vue.prototype.$d_showObjectCard = function (objectIdOrKey, objectTypeKey, newTab = false, modalTab = false, subtypeKey) {
      if (objectIdOrKey != null && objectTypeKey != null) {
        if (objectTypeKey === 'trafficLightT7') {
          objectTypeKey = 'trafficLight'
        }

        if (this.$d_hasObjectCardAccess(objectTypeKey, subtypeKey)) { // TODO type_open_access
          if (newTab) {
            window.open(getObjectCardURL(objectIdOrKey, objectTypeKey, subtypeKey), '_blank')
          } else {
            if (modalTab) {
              this.$q.dialog({
                component: ObjectCardDialog,
                parent: this,
                objectId: objectIdOrKey,
                objectType: objectTypeKey,
                subtypeKey: subtypeKey
              })
            } else {
              this.$router.push(getObjectCardURL(objectIdOrKey, objectTypeKey, subtypeKey))
            }
          }
        }
      }
    }

    Vue.prototype.$d_getUrlObjectCard = function (objectIdOrKey, objectTypeKey, subtypeKey) {
      if (objectIdOrKey != null && objectTypeKey != null) {
        if (objectTypeKey === 'trafficLightT7') {
          objectTypeKey = 'trafficLight'
        }

        if (this.$d_hasObjectCardAccess(objectTypeKey, subtypeKey)) {
          return getObjectCardURL(objectIdOrKey, objectTypeKey, subtypeKey)
        } else {
          return ''
        }
      }
      return ''
    }

    Vue.prototype.$d_showAdminObjectCard = function (objectId) {
      if (objectId != null) {
        window.open((process.env.VUE_APP_BACKEND_HREF || '/') + 'pages/objectconf/' + objectId, '_blank')
      }
    }

    Vue.prototype.$d_ask = function () {
      if (arguments.length === 1 && typeof arguments[0] === 'object') {
        const config = arguments[0]
        return this.$q.dialog({
          component: AskPropsWindow,
          parent: this,
          config: config
        })
      } else {
        const [callback, header, propsConfig, buttons, warning] = arguments
        return this.$q.dialog({
          component: AskPropsWindow,
          parent: this,
          config: {
            callback,
            header,
            warning,
            propsConfig,
            buttons
          }
        })
      }
    }

    Vue.prototype.$d_askConfirmation = function (header, warning) {
      return new Promise((resolve) => {
        this.$d_ask((data, action) => {
          resolve(action === 'yes')
        }, header, {}, {
          yes: 'Подтвердить',
          no: 'Отмена'
        }, warning)
      })
    }

    Vue.prototype.$d_hasFullAccess = function () {
      const user = this.$store.getters.getUser
      return !!user && user.fullAccess
    }

    Vue.prototype.$d_hasRole = function (...roles) {
      const user = this.$store.getters.getUser
      return !!user && user.hasSystemRole(...roles)
    }

    Vue.prototype.$d_hasOperation = function (operation) {
      const user = this.$store.getters.getUser
      return !!user && user.hasOperation(operation)
    }

    Vue.prototype.$d_hasObjectCardAccess = function (type, subtypeKey) {
      if (!type) {
        return false
      }
      const user = this.$store.getters.getUser
      if (user) {
        if (user.fullAccess) {
          return true
        }
        // TODO type_open_access проверка доступа к типам объектов

        if (user.hasSystemRoleStrict('publicationRead')) {
          return false
        }

        switch (type) {
          case 'employee':
            return (user.hasOperation('employeesView') || user.hasOperation('employeesViewFull') || subtypeKey === 'forkLiftDriver') && !user.specialExternalAccess
          case 'vehicle':
          case 'project':
          case 'deltaOrganization':
          case 'tool':
          case 'stock':
          case 'trafficLight':
          case 'trafficLightT7':
          case 'cameraFVF':
          case 'cameraTV':
          case 'cameraVA':
          case 'serverEquipment':
          case 'accessBoxKTO':
          case 'TOI':
          case 'complexAudio':
          case 'TEI':
          case 'transportDetector':
          case 'TransportStop':
          case 'cameraMetro':
          case 'stationMetro':
          case 'vestibuleMetro':
          case 'emergencyStandMetro':
          case 'tourniquetGroupMetro':
          case 'controlSectionMetro':
          case 'vehicleProvision':
          case 'vehicleGroupType':
          case 'krotosCameraMetroIncident':
          case 'stationaryPositioningDevice':
            return true
          case 'serviceObjectMaintenanceNote':
            return !user.hasSystemRoleStrict('krotos')
          default:
            break
        }
      }
      return false
    }
  }
}
export default deltaPlugins
